"use client";

import React from "react";

const LocationMap = () => {
  return (
    <div className="w-full h-[450px] md:h-[500px] overflow-hidden shadow-lg ">
      <iframe
        title="Google Maps Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3318.7297389697023!2d73.06701837628084!3d33.715941535412206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfbf7d90767abd%3A0x2cba726d067c04f5!2sAzeem%20Mansion!5e0!3m2!1sen!2s!4v1754124200438!5m2!1sen!2s"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="w-full h-full border-0"
      ></iframe>
    </div>
  );
};

export default LocationMap;
